import { CustomCarrierCodes } from "../constants/custom-carrier";
export const checkIfHomeDelivery = (methodAndCarrier) => {
    // CustomCarrierCode.jtiPickup represents a custom delivery option.
    // If the methodAndCurrier does not include this option,
    // it suggests that it's a home delivery.
    if (methodAndCarrier === undefined) {
        return true;
    }
    return !methodAndCarrier.includes(CustomCarrierCodes.jtiPickup);
};
//# sourceMappingURL=checkIfAtHomeDelivery.js.map